import React from "react";

const AUTH_ERROR_PATTERNS = [
  /401/,
  /403/,
  /unauthorized/i,
  /forbidden/i,
  /token/i,
  /jwt/i,
  /session/i,
  /not authenticated/i,
];

const CHUNK_ERROR_PATTERNS = [
  /loading chunk/i,
  /failed to fetch/i,
  /dynamically imported module/i,
  /cannot find module/i,
];

function isAuthError(error) {
  const msg = error?.message || error?.toString() || "";
  return AUTH_ERROR_PATTERNS.some((p) => p.test(msg));
}

function isChunkError(error) {
  const msg = error?.message || error?.toString() || "";
  return CHUNK_ERROR_PATTERNS.some((p) => p.test(msg));
}

function logout() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this._autoTimer = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);

    if (isAuthError(error)) {
      // Auth error — clear session and redirect to login
      logout();
      return;
    }

    if (isChunkError(error)) {
      // Chunk load failure — hard reload fetches fresh bundles
      window.location.reload();
      return;
    }

    // Unknown render error — auto-refresh after 3s
    this._autoTimer = setTimeout(() => {
      window.location.reload();
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this._autoTimer);
  }

  render() {
    // Render nothing visible while auto-action fires
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export { ErrorBoundary };
export default ErrorBoundary;

